import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Icon,
  Menu,
  Dropdown,
} from 'antd';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { ExportToCsv } from "export-to-csv";

import styles from './TableExport.module.css';

class TableExport extends PureComponent {
  export = (payload, title) => {
    const { data, fields } = payload;
    let tableData = [];
    for (let key in data) {
      const {
        rowId,
        isActive,
        is_approved,
        is_paused,
        ...rest
      } = data[key];

      let item = Object.values(rest);
      item = item.map(el => String(el))
      tableData.push(item);
    }

    const excludeNames = ['Approved', 'Paused'];
    const field = [];
    for (let key in fields[0]) {
      if (excludeNames.indexOf(fields[0][key]['name']) === -1) {
        field.push(fields[0][key]['name']);
      }
    }

    const options = {
      fieldSeparator: ';',
      quoteStrings: ' ',
      decimalSeparator: ' ',
      showLabels: true,
      showTitle: true,
      useTextFile: false,
      useBom: true,
      headers: field,
      filename: 'report',
      title,
    };

    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(tableData);
  };

  exportPDF = (data, title) => {
    const unit = 'pt';
    const size = 'A4';
    const orientation = 'landscape';

    const marginLeft = 15;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(10);

    const objectHeader = Object.values(data.fields[0]);
    let headers = [];
    for (let key in objectHeader) {
      headers.push(objectHeader[key]['name'])
    };

    const datadata = data.data.map((el) => {
      const curEl = {...el};
      return Object.values(curEl);
    });

    const headerStyles = {
      cellPadding: 7,
      fontSize: 8,
    };

    const bodyStyles = {
      cellPadding: 7,
      fontSize: 8,
      overflow: 'visible',
    };

    const content = {
      theme: 'striped',
      headerStyles: headerStyles,
      bodyStyles: bodyStyles,
      startY: 40,
      head: [headers],
      body: datadata,
      margin: 15,
    };

    doc.text(title, marginLeft, 20);
    doc.autoTable(content);
    doc.save('report.pdf')
  };

  handleClick = (e, data, title) => {
    if (e.key === 'csv') this.export(data, title);
    if (e.key === 'pdf') this.exportPDF(data, title);
  };

  render() {
    const { data, title } = this.props;
    const menu = (
      <Menu
        style={{ width: 100 }}
        onClick={(e) => this.handleClick(e, data, title)}
      >
        <Menu.Item key="csv">
          <Icon type="file-text" />
          To CSV
        </Menu.Item>
        <Menu.Item key="pdf">
          <Icon type="file-pdf" />
          To PDF
        </Menu.Item>
      </Menu>
    );

    return (typeof data === 'object' && (!!data.data && data.data.length > 0)) ? (
      <div className={styles['export-container']}>
        <Dropdown
          trigger={['click']}
          overlay={menu}
        >
          <Button type="primary">
            Export <Icon type="down" />
          </Button>
        </Dropdown>
      </div>
    ) : null;
  }
}

TableExport.propTypes = {
  data: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
};

export default TableExport;
